import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false

import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

// vue-moment for easy use in filters
Vue.use(require('vue-moment'))

// don't use cookies! this is only for a link off to the legacy portal
Vue.use(require('vue-cookies'))

new Vue({
  router,
  store,
  vuetify,
  theme: {
    primary: '#7B7B7B',
    secondary: '#54318F',
    //accent: '#8c9eff',
    //error: '#b71c1c'
  },
  render: h => h(App)
}).$mount('#app')
